<template>
  <td>
    <ToolTip v-if="failMessage">
      <span class="lamp" :class="statusClass" @click="$emit('click')">{{ statusText }}</span>
      <template #content>
        <dd class="cont" v-html="failMessage"></dd>
      </template>
    </ToolTip>
    <span v-else class="lamp" :class="statusClass" @click="$emit('click')">{{ statusText }}</span>
  </td>
</template>

<script>
export default {
  props: {
    displayType: {
      type: String,
      default: 'MAIN', // MAIN
    },
    statusCode: String,
    failMessageCode: String,
  },
  computed: {
    typeData() {
      switch (this.displayType) {
        case 'MAIN':
          return {
            WAIT: {text: '전송대기', class: 'gray'},
            RESEND_WAIT: {text: '전송대기', class: 'gray'},
            PARTIAL: {text: '전송완료', class: 'blue'},
            FAIL: {text: '전송완료', class: 'blue'},
            COMPLETE: {text: '전송완료', class: 'blue'},
          };
        case 'RCP':
          return {
            WAIT: {text: '전송대기', class: 'gray'},
            RESEND_WAIT: {text: '전송대기', class: 'gray'},
            PARTIAL: {text: '일부완료', class: 'green'},
            FAIL: {text: '알림실패', class: 'red'},
            COMPLETE: {text: '알림성공', class: 'blue'},
          };
      }
    },
    statusData() {
      return this.typeData[this.statusCode];
    },
    statusText() {
      return this.statusData ? this.statusData.text : '-';
    },
    statusClass() {
      return this.statusData ? this.statusData.class : '';
    },
    failMessage() {
      if (this.statusCode === 'FAIL' && this.failMessageCode) {
        switch (this.failMessageCode) {
          case 'NOT_FOUND_DEVICE':
            return 'NUGU 디바이스 정보를 찾을 수 없습니다.<br>TID와 Device ID가 올바른지 확인해 주세요.';
          case 'TOKEN_EXPIRED':
            return 'NUGU 디바이스 토큰이 만료되었습니다.';
          case 'DEVICE_NETWORK_ERROR':
            return 'NUGU 디바이스가 연결되어 있지 않았습니다.<br>전원 및 네트워크 연결 상태 확인이 필요합니다.';
          case 'UNKNOWN':
          default:
            return '일시적인 오류로 알림 전송되지 못했습니다.';
        }
      }
    },
  },
};
</script>

<style></style>
